import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_REGISTER: 'FETCH_REGISTER',
  RESET: 'RESET',
}

const fetchReset = async state => {
  console.log("RESETDATA")
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchVersion = async (state, register) => {
  // console.log(version, "test...");
  state = {
    ...state,
    isStatus: register.status,
    expireToken: sanitizeExpire({
      status: register.status,
      data: register.data,
      name: 'registerObject',
    }),
    data: sanitizeData({
      status: register.status,
      data: register.data,
      name: 'registerObject',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REGISTER:
      return fetchVersion(state, action.register)
      case actionTypes.RESET:
        return fetchReset(state)
    default:
      return state
  }
}

const register = {
  init,
  actionTypes,
  fetchReset,
  reducer,
}

export default register
